import { Entidad } from "../Entidad";
import { IGrado } from "../entidad/Grado";
import { _DICC_ASIGNACION_ESCOLARIDAD_GRADOS } from "../modulo/Escolaridad";
import { _DICC_ASIGNACION_GRADO_GRUPOS } from "../modulo/Grado";
import { DataModuloMain } from "../ModuloMain";
import { MGrupo } from "./MGrupo";
import { ModelAdapter } from "./ModelAdapter";

export class MGrado extends ModelAdapter<IGrado> implements IGrado {
    readonly IdNivel: number;
    readonly IdKinder: number;
    readonly IdEscolaridad: number;
    readonly Nombre: string;
    readonly EnUso: boolean;
    readonly Modificacion: string;

    // =================================================
    // PROPIEDADES ADICIONALES
    // =================================================
    KinderFiltro: number[];

    constructor(data: IGrado) {
        super(data);
        this.KinderFiltro = [this.IdKinder];
    }

    // =================================================
    // GETTERS ADICIONALES
    // =================================================
    get NombreKinder(): string {
        return DataModuloMain._GetDataValueFieldByName("Escuela", this.IdKinder, "Nombre") || "";
    }

    public getGruposEnGrado(): Map<number, MGrupo> {
        return (_DICC_ASIGNACION_GRADO_GRUPOS.get(this.IdNivel) || new Map());
    }

    public getAlumnosEnGrado(): Array<Entidad.IAlumno> {
        return DataModuloMain._GetReqDataArrayByName("Alumno")
            .filter(d => (d.IdGrado == this.IdNivel));
    }
}